import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getProvinciasClientes`, method: 'GET', body: null, token: token})
}
